

































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

import { TagData } from './types'

@Component({
})
export default class Tags extends Vue {
  @Prop({ type: Array }) readonly tags!: Array<TagData>

  currentHint: null | TagData['hint'] = null

  isOpen = false

  @Watch('currentHint')
  hintWatcher(component: null | TagData['hint']): void {
    if (component) {
      this.isOpen = true
    }
  }

  tagClick(tag: TagData): void {
    if (tag.hint) {
      this.currentHint = tag.hint
    }
  }
}
